export const normalizeMaterial = (value: string) => {
  if (!value) return value;
  
  return value.toUpperCase();
};
